import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export const walkthroughSlice = createSlice({
    name: "walkthrough",
    // initial session state as SessionDataI interface model
    initialState: {
        disabled: true,
        step: 0,
        flow: ""
    },
    reducers: {
        /**
         * @param current state
         * @param action payload with new data to update state
         */
        setWalkthrough: (state, action: PayloadAction<{ disabled: boolean }>) => {
            state.disabled = true; //TODO Walkthrough is deactivated, to change it again change false to action.payload.disabled
        },
        setWalkthroughStep: (state, action: PayloadAction<{step: number}>) => {
            state.step = action.payload.step;
        },
        setWalkthroughFlow: (state, action: PayloadAction<{flow: string}>) => {
            state.flow = action.payload.flow;
        },
    },
});

export const { setWalkthrough, setWalkthroughStep, setWalkthroughFlow } = walkthroughSlice.actions;
export default walkthroughSlice.reducer;
